export enum AnalyticsValueSources {
  VALUE = 'Value',
  GAIN = 'Gain',
}
